module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/static/locales/whitelist_es.json
// module id = 336
// module chunks = 0